module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2a"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct",
    attrs: {
      "id": "krintro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#kintro"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "krch1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter01#kch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flowers & Terrariums")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "krch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter02#kch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SANS SERIF")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "krch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter03#kch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("SERIF")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "krch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter04#kch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Script")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "krch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter05#kch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BLOCK and DIMENSIONAL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "krch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter06#kch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMBINING Styles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "krch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter07#kch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POSITIVE and NEGATIVE Spaces")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "krch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter08#kch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EMBELLISHMENTS and BORDERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "krch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter09#kch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRUITS and VEGGIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "krch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter10#kch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("brush lettering")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "krch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter11#kch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MANY WAYS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "krch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter12#kch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("BEYOND")]), _vm._v(" the "), _c('b', [_vm._v("PAGE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "krauthor"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Author#kauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT the AUTHOR")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2f62c52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 75
// module chunks = 0